import React, { useCallback } from 'react';
import { twMerge } from 'tailwind-merge';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { toggleMeetingHostControlsActive } from 'flow/actions/meeting-actions';
import {
    selectActiveMeetingHostControlsActive,
    selectShouldShowHostControlsPanel,
} from 'flow/selectors/meeting-selectors';
import { getFooterButtonHiddenClass } from 'flow/utils/meeting-footer-utils';
import MeetingButton from 'flow/components/meeting/MeetingButton';

const ButtonToggleHostControls = () => {
    const dispatch = useAppDispatch();
    const { i18next } = useAppContext();

    const shouldShow = useAppSelector(selectShouldShowHostControlsPanel);
    const hostControlsActive = useAppSelector(
        selectActiveMeetingHostControlsActive,
    );

    const onClick = useCallback(() => {
        dispatch(toggleMeetingHostControlsActive());
    }, [dispatch]);

    if (!shouldShow) return null;

    return (
        <div
            className={twMerge(
                'flex items-center select-none',
                getFooterButtonHiddenClass(),
            )}
        >
            <MeetingButton
                iconType="adminPanelSettingsOutlined"
                active={hostControlsActive}
                subtleActive={true}
                invertOnHover={true}
                callback={onClick}
                hoverText={i18next.t('videoconference.host_controls.title')}
                circular={true}
            />
        </div>
    );
};

export default ButtonToggleHostControls;
